<div class="container">
    <div class="row">
        <div class="col-md-4">
            <label for="motivoId" class="form-label">Descripción de la novedad</label>
            <select id="motivoId" class="form-select" aria-label="Default select example" name="motivoId"
                [(ngModel)]="dataNovedad.motivoNovedadId" (change)="onSelect()" #MotivoNovedadId="ngModel" required>
                <option selected disabled>Seleccionar</option>
                <option *ngFor="let option of $parametricList.typeNewsList" [value]="option.idParametroDetalle">
                    {{option.vcNombre}}
                </option>
            </select>

            <strong class="invalid-feedback d-block"
                *ngIf="MotivoNovedadId.invalid && (MotivoNovedadId.dirty || MotivoNovedadId.touched)">
                <span *ngIf="MotivoNovedadId.errors?.['required']">
                    Campo obligatorio
                </span>
            </strong>
        </div>

        <div class="col-md-4">
            <label for="ids" class="form-label">ID Asociado</label>
            <input id="ids" type="text" class="form-control" [value]="codeSolicitud" name="id" disabled>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-12">
            <label for="" class="form-label">Justificación de la novedad</label>
            <textarea class="form-control" rows="2" maxlength="800" name="justificacion"
                [(ngModel)]="dataNovedad.txJustificacion" #txJustificacion="ngModel" required>
                </textarea>

            <strong class="invalid-feedback d-block"
                *ngIf="txJustificacion.invalid && (txJustificacion.dirty || txJustificacion.touched)">
                <span *ngIf="txJustificacion.errors?.['required']">
                    Campo obligatorio
                </span>
                <span *ngIf="txJustificacion.errors?.['maxlength']">
                    Máximo 800 caracteres
                </span>
            </strong>
        </div>
    </div>

    <br>
    <br>

    <div class="d-flex flex-row gap-2">
        <div class="col-md-3">
            <button class="btn btn-secondary col-md-12" type="button"
                [disabled]="MotivoNovedadId.invalid || txJustificacion.invalid"
                (click)="addNews()">
                    AGREGAR NOVEDAD
            </button>
        </div>

        <div class="col-md-3">
            <button class="btn btn-secondary col-md-12" type="button" #autofocus
                (click)="onClose()">
                CANCELAR
            </button>
        </div>
    </div>

    <br>

    <div class="container overflow-auto">
        <table class="table table-bordered text-center">
            <thead>
                <tr>
                    <th scope="col">ID solicitud</th>
                    <th scope="col">Referente que solicitó el servicio</th>
                    <th scope="col">Fecha de solicitud</th>
                    <th scope="col">Nombre del Directivo</th>
                    <th scope="col">Motivo de la novedad</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{dataTableSolicitud.id}}</td>
                    <td>{{dataTableSolicitud.referenteSolicitud}}</td>
                    <td>{{dataTableSolicitud.fechaSolicitud}}</td>
                    <td>{{dataTableSolicitud.nombreDirectivo}}</td>
                    <td>{{dataTableSolicitud.motivo}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>